export function generateNewDocumentId() {
  return 'new-' + Math.random().toString(36).substring(2, 12)
}
